import { createFileRoute } from '@tanstack/react-router'
import { PublicHolidaysSettings } from '@/features/organizations/settings/public-holidays'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/public-holidays'
)({
  component: PublicHolidaysSettings,
})
